import axios from 'axios';

export const BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000';

const API = axios.create({
  baseURL: `${BASE_URL}/api`,
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export const register = (formData) => API.post('/auth/register', formData);
export const login = (formData) => API.post('/auth/login', formData);
export const getMe = () => API.get('/auth/me');
export const changePassword = (data) => API.put('/auth/change-password', data);
export const deleteAccount = (data) => API.delete('/auth/account', { data });

export const getProjects = () => API.get('/projects');
export const createProject = (data) => API.post('/projects', data);
export const getProject = (id) => API.get(`/projects/${id}`);
export const updateProject = (id, data) => API.put(`/projects/${id}`, data);
export const updateVictorySettings = (id, data) => API.put(`/projects/${id}/victory`, data);
export const deleteProject = (id) => API.delete(`/projects/${id}`);

export const getScreens = (projectId) => API.get(`/screens/${projectId}`);
export const uploadScreen = (projectId, formData) => API.post(`/screens/${projectId}`, formData);
export const deleteScreen = (id) => API.delete(`/screens/${id}`);
export const reorderScreens = (projectId, screens) => API.put(`/screens/${projectId}/reorder`, { screens });

export const getHotspots = (screenId) => API.get(`/hotspots/${screenId}`);
export const createHotspot = (screenId, data) => API.post(`/hotspots/${screenId}`, data);
export const updateHotspot = (id, data) => API.put(`/hotspots/${id}`, data);
export const deleteHotspot = (id) => API.delete(`/hotspots/${id}`);

export const getPackages = () => API.get('/packages');
export const createPackage = (data) => API.post('/packages', data);
export const getPackage = (id) => API.get(`/packages/${id}`);
export const updatePackage = (id, data) => API.put(`/packages/${id}`, data);
export const deletePackage = (id) => API.delete(`/packages/${id}`);

export const getAllScreenshots = () => API.get('/screenshots');
export const updateScreenshot = (id, data) => API.put(`/screenshots/${id}`, data);

export const getTags = () => API.get('/tags');
export const createTag = (data) => API.post('/tags', data);
export const updateTag = (id, data) => API.put(`/tags/${id}`, data);
export const deleteTag = (id) => API.delete(`/tags/${id}`);
export const assignTag = (projectId, tagId) => API.put(`/tags/project/${projectId}/tag/${tagId}`);
export const removeTag = (projectId, tagId) => API.delete(`/tags/project/${projectId}/tag/${tagId}`);